import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useLegalModal } from "@/components/LegalModal";
import { FileText } from "lucide-react";

export const AUCTION_TERMS_SLUG = "auction_terms";

// Estado de aceptación de la versión vigente + registro de aceptación (append-only en backend).
export function useAuctionTerms() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const refresh = useCallback(() => {
    if (!user) return;
    api.get("/auctions/terms/status").then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, [user]);
  useEffect(() => { refresh(); }, [refresh]);
  const accept = async (context) => {
    if (status?.accepted) return;
    const r = await api.post("/auctions/terms/accept", { version: status?.version, context });
    setStatus({ version: r.data.version, accepted: true, accepted_at: r.data.accepted_at });
  };
  return { status, accepted: !!status?.accepted, accept, refresh };
}

export function TermsLink({ className = "", testid = "auction-terms-link", children }) {
  const { open } = useLegalModal();
  return (
    <button type="button" onClick={() => open(AUCTION_TERMS_SLUG)} data-testid={testid}
            className={`inline-flex items-center gap-1.5 text-[13px] font-bold text-[#FF4438] hover:underline ${className}`}>
      {children || <><FileText size={13} /> Términos y Condiciones de Subastas</>}
    </button>
  );
}

export function TermsCheck({ checked, onChange, testid }) {
  return (
    <label className="flex items-start gap-3 text-[13px] text-white/75 leading-relaxed cursor-pointer" data-testid={testid}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
             data-testid={`${testid}-input`} className="mt-0.5 h-5 w-5 accent-[#FF4438] flex-none" />
      <span>Acepto los <TermsLink testid={`${testid}-link`} className="!text-[13px]">Términos y Condiciones de Subastas</TermsLink>, que complementan los Términos generales de HitTCG.</span>
    </label>
  );
}

export function TermsAccepted({ status, testid = "auction-terms-accepted" }) {
  if (!status?.accepted) return null;
  return (
    <p className="text-[12px] text-white/50" data-testid={testid}>
      Aceptaste los <TermsLink className="!text-[12px]" testid={`${testid}-link`}>Términos de Subastas</TermsLink> · versión {status.version} · {new Date(status.accepted_at).toLocaleString("es-EC", { dateStyle: "short", timeStyle: "short" })}
    </p>
  );
}

export const FEE_NON_REFUNDABLE = "La tarifa por días no es reembolsable. Si el admin rechaza tu subasta, la corriges y la reenvías SIN pagar de nuevo: el pago queda a favor de esa subasta.";
